<template>
    <div v-cloak class="Resource_act">
        <!-- 头部banner图 -->
        <div class="swiper">
            <div class="toptexts">
                <div class="imgtitle">展映基地</div>
                <div class="texts">赋能财商教育，助力财务自由，引领财富增长</div>
            </div>
        </div>
        <div class="Bread"><Bread :list="breadList" /></div>
        <!-- 中间内容 -->
        <div class="containersss">
            <div class="act_width1200 flex">
                <img :src="details.Image[0]" class="img_477 img_cover" />
                <div class="ma-l-20 ma-t-20">
                    <div class="fon-18 t-omit-1 font-bold">{{ details.Name }}</div>
                    <div class="ma-t-30">
                        <div class="ma-b-10">
                            活动日期：{{ details.StartTime }} - {{ details.EndTime }}
                        </div>
                        <div class="ma-b-10">人数上限：{{ details.MaxCount }}</div>
                        <div class="ma-b-10">门票价格：{{ details.MaxCount }}</div>
                        <div class="ma-b-10">联系人员：{{ details.Linkman }}</div>
                        <div class="ma-b-10">联系电话：{{ details.Phone }}</div>
                        <div class="ma-b-10 t-omit-1">活动地点：{{ details.Address }}</div>
                    </div>
                    <div class="act_absolute flex f-between f-center">
                        <div class="btn_180 flex f-center f-jcenter c-fff"
                             @click="plays"
                             v-if="details.CanApply && !details.IsActivity">
                            立即参加
                        </div>
                        <div class="btn_180 flex f-center f-jcenter c-fff" v-if="!details.CanApply">
                            已结束
                        </div>
                        <div class="btn_180 flex f-center f-jcenter c-fff" v-if="details.IsActivity">
                            已报名
                        </div>
                        <div class="c-8a fon-12 flex f-center">
                            <img src="../img/iconeye.png" class="ma-l-40 ma-r-10 img_14" />
                            {{ details.ViewCount }}人浏览
                        </div>
                    </div>
                </div>
            </div>
            <div class="act_bot_box flex f-between">
                <div class="act_left">
                    <div class="ma-20">
                        <div class="flex f-center ma-b-20">
                            <div class="green_tabs"></div>
                            <div class="fon-18 weight500 ma-l-20">活动内容</div>
                        </div>
                        <div class="817px" v-html="details.Detail"></div>
                        <!-- <el-carousel trigger="click" height="817px">
                          <el-carousel-item
                            v-for="(item, index) in details.Image"
                            :key="index"
                          >
                            <img :src="item" class="img_817" />
                          </el-carousel-item>
                        </el-carousel> -->
                    </div>
                </div>
                <div class="act_right">
                    <div class="ma-20">
                        <div class="flex f-center ma-b-20">
                            <div class="green_tabs"></div>
                            <div class="fon-16 ma-l-20 weight500">可能感兴趣</div>
                        </div>

                        <div>
                            <div class="b-b-e ma-t-20"
                                 v-for="(item, index) in details.SimilarList"
                                 :key="index"
                                 @click="toDetail(item.Id)">
                                <img :src="item.MainImage" class="img_cover img_335" />
                                <div class="ma-t-10 fon-18 bold">{{ item.Name }}</div>
                                <div class="ma-tb-20 fon-12 c-41 font-bold">
                                    <!-- {{ item.StartTime }} - {{ item.EndTime }} -->
                                    {{ item.StartTime }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="play" width="40%" :show-close="false">
            <div class="pa-tb-40">
                <div class="t-center fon-18 font-bold">活动报名</div>

                <div class="width419 ma-center">
                    <el-input placeholder="请输入姓名"
                              class="ma-tb-30"
                              v-model="name"></el-input>
                    <el-input placeholder="请输入联系方式" v-model="phone"></el-input>
                </div>

                <div>
                    <div class="flex ma-t-70 f-around">
                        <div class="btn_green flex f-center f-jcenter" @click="submit">
                            提交
                        </div>
                        <div class="btn_white flex f-center f-jcenter"
                             @click="play = false">
                            取消
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<style lang="scss">
    /* 大屏 宽度大于768 */
    @media (min-width: 768px) {
        body {
            background: #f7f7f7;
        }

        .img_335 {
            width: 335px;
            height: 199px;
        }

        .img_817 {
            width: 817px;
        }

        .green_tabs {
            width: 4px;
            height: 20px;
            background: #fb004d;
            border-radius: 2px;
        }

        .act_bot_box {
            width: 1200px;
            margin: 40px auto;
        }

        .act_left {
            width: 782px;
            min-height: 891px;
            background: #fff;
        }

        .act_right {
            width: 371px;
            min-height: 891px;
            background: #fff;
        }

        .act_absolute {
            position: absolute;
            width: 600px;
            bottom: 20px;
        }

        .btn_180 {
            width: 180px;
            height: 40px;
            background: #fb004d;
            border-radius: 50px;
        }

        .img_477 {
            width: 477px;
            height: 333px;
            display: block;
        }

        .act_width1200 {
            width: 1200px;
            height: 333px;
            margin: 40px auto;
            background: #fff;
            position: relative;
        }

        .Resource_act {
            min-width: 1200px;
            background: #f7f7f7;
        }

        .Resource_act .swiper {
            width: 100%;
            height: 314px;
            background-image: url(../img/three_1.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: relative;

            .toptexts {
                width: 736px;
                position: absolute;
                top: 28%;
                margin: 0 auto;
                left: 50%;
                margin-left: -368px;
                font-size: 20px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                color: #fff;
                opacity: 0.75;
                text-align: center;

                .texts {
                    line-height: 30px;
                    letter-spacing: 3px;
                    font-size: 16px;
                }

                .imgtitle {
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }
            }
        }

        .fy {
            margin-top: 55px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .Resource_act .containersss {
            width: 100%;
            // height: 600px;
            min-height: 1150px;
            background: #f7f7f7;
            box-sizing: border-box;
            padding: 0 40px 30px;
            margin: 0 auto;
        }

        .Resource_act .container {
            .el-tabs__header {
                display: flex;
                justify-content: center;
            }

            .el-tabs__content {
                min-width: 1080px;
                margin: 0 auto;
            }

            .el-tabs__item {
                padding: 0 60px;
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: #333333;
            }

            .el-tabs__active-bar {
                height: 4px;
                font-weight: bold;
                background: #fb004d;
            }

            .is-active {
                font-size: 14px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                font-weight: bold;
                color: #fb004d;
            }

            .el-tabs__content {
                margin-top: 45px;
            }
        }

        .Resource_act .student {
            width: 1100px;
            height: 106px;
            margin-bottom: 32px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;

            .img-left {
                width: 20%;
                height: 106px;

                .img-lefts {
                    width: 187px;
                    height: 106px;
                }
            }

            .text-right {
                width: 80%;

                .title {
                    font-size: 14px;
                    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                    font-weight: bold;
                    color: #333333;
                    margin-top: 3px;
                    margin-bottom: 5px;
                }

                .text-detail {
                    padding-right: 100px;
                    box-sizing: border-box;
                    font-size: 12px;
                    line-height: 18px;
                    font-family: MicrosoftYaHei;
                    color: rgba(102, 102, 102, 1);
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    line-clamp: 3;
                    -webkit-box-orient: vertical;
                }

                .icons {
                    // width: 100%;
                    margin-top: 8px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .deletes {
                        font-size: 12px;
                        font-family: MicrosoftYaHei;
                        color: rgba(102, 102, 102, 1);
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .icons-right-children {
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;

                            i {
                                font-size: 18px;
                            }
                        }
                    }

                    .icons-left {
                        width: 100%;
                        padding-right: 100px;
                        box-sizing: border-box;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        .icons-left-children {
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;

                            div {
                                font-size: 12px;
                                font-family: MicrosoftYaHei;
                                color: rgba(102, 102, 102, 1);
                                margin-left: 8px;
                            }
                        }
                    }

                    .delete-right {
                        width: 40%;

                        .icons-right-children {
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;

                            div {
                                font-size: 12px;
                                font-family: MicrosoftYaHei;
                                color: rgba(102, 102, 102, 1);
                                margin-left: 8px;
                            }
                        }
                    }
                }
            }
        }

        .ma-t-70 {
            margin-top: 70px;
        }

        .box {
            // width: 1200px;
            height: 175px;
            margin-top: 20px;
            border-bottom: #eee 1px solid;
        }

        .ma-t-60 {
            margin-top: 60px !important;
        }

        .ma-t-10 {
            margin-top: 10px !important;
        }

        .btn_green {
            width: 220px;
            height: 40px;
            background: #fb004d;
            border-radius: 20px;
            color: #fff;
        }

        .btn_white {
            width: 220px;
            height: 40px;
            background: #ffffff;
            border: 1px solid #fb004d;
            border-radius: 20px;
            color: #fb004d;
        }

        .img_230 {
            width: 230px;
            height: 149px;
        }

        .c-5 {
            color: #555555;
        }

        .height300 {
            height: 80px;
        }

        .width419 {
            width: 419px;
        }

        .Bread {
            margin-top: 10px;
        }
    }
</style>
<script>
    import { ActivityDetail, getuser, sign } from "../api.js";
    import Bread from "../components/Bread.vue";
    // studycollect
    export default {
        name: "Activity",
        components: { Bread },
        data() {
            return {
                play: false,
                details: { Image: [] },
                name: "",
                id: 0,
                phone: "",
                breadList: [
                    {
                        name: "展映基地",
                        path: "/Practice",
                    },
                    {
                        name: "活动详情",
                        path: "/Activity",
                    },
                ],
            };
        },

        created() {
            console.log("created----");
            this.id = this.$route.query.id;

            this.detail();
        },
        beforeRouteEnter(to, from, next) {
            window.scroll(0, 0);

            next();
        },

        // 其他页面进来时更新初始数据
        activated() {
            // console.log(1)
        },

        watch: {
            $route(o) {
                if (o.name == 'Activity' && o.query.id != this.id) {
                    this.id = this.$route.query.id;
                    this.detail();
                }
            }
        },

        methods: {
            toDetail(e) {
                this.$router.push({
                    path: "/Activity",
                    query: {
                        id: e,
                    },
                });
            },

            //
            detail() {
                //   let token = localStorage.getItem("AccessToken") || "";
                let data = {
                    id: this.id,
                    // token: token,
                };
                ActivityDetail(data).then((res) => {
                    if (res.data.Code == 0) {
                        console.log(res);
                        this.details = res.data.Data;
                    }
                });
            },
            plays() {
                let token = localStorage.getItem("AccessToken") || "";
                if (!token) {
                    this.$confirm("您还未登录请先登录?", "提示", {
                        confirmButtonText: "去登录",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            this.$router.push("/login");
                        })
                        .catch(() => {
                            // this.$router.go(0);
                        });
                } else {
                    this.play = true;
                    let token = localStorage.getItem("AccessToken");
                    let data = { token: token };
                    getuser(data).then((res) => {
                        if (res.data.Code == 0) {
                            this.name = res.data.Data.Name;
                            this.phone = res.data.Data.Phone;
                        }
                    });
                }
            },

            upload(e) {
                window.open(e, "_blank");
            },

            //报名提交
            submit() {
                var that = this;
                var reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;

                if (this.name == "") {
                    this.$message.error("姓名不能为空哦！");
                    return;
                }
                if (this.phone.length < 1) {
                    this.$message.error("手机号不能为空哦！");
                    return;
                } else if (!reg.test(this.phone)) {
                    this.$message.error("手机格式不正确！");
                    return;
                }

                let token = localStorage.getItem("AccessToken");
                let data = {
                    Token: token,
                    Name: this.name,
                    Phone: this.phone,
                    Id: this.id,
                };
                sign(data).then((res) => {
                    console.log(res);
                    if (res.data.Code == 0) {
                        that.$message.success("报名成功");
                        that.play = false;
                    } else {
                        that.$message({
                            message: res.data.Message,
                            type: "warning",
                            center: true,
                            customClass: "sps",
                        });
                    }
                });
            },
        },
    };
</script>
